import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
// import { createLogger } from "redux-logger";

import reducers from './../reducers';

// const logger = createLogger();
const initialState = {};


const middleware = [];
middleware.push(thunkMiddleware);
// middleware.push(createLogger());
/*

const store = createStore(
    reducers,
    undefined,
    compose(
        applyMiddleware(...middleware),
    )
);

export default store;
*/


export default function configureStore() {
    let store;

    if (module.hot) {
        store = createStore(
            reducers,
            initialState,
            compose(
                applyMiddleware(thunkMiddleware
                    // , logger
                ),
                window.devToolsExtension ? window.devToolsExtension() : f => f
            )
        );
    } else {
        store = createStore(
            reducers,
            initialState,
            compose(applyMiddleware(thunkMiddleware), f => f)
        );
    }

    return store;
}



// WEBPACK FOOTER //
// ./src/redux/store/index.js